import Vue from 'vue'
import store from 'store'
import moment from 'moment-timezone'
import getOptionExpiryStamp from 'utils/getOptionExpiryStamp'
import { TIME_ZONE } from 'const/common'

/**
 * @desc 期权名称格式化筛选器。目前支持三种展示形式，若不指定 mode 返回所有的拼接方式
 * @example
 *  mode=0 AAPL 330.0 CALL JAN, 01 - 单行展示
 *  mode=1 AAPL 330.0 CALL - 两行展示第一个
 *  mode=2  JAN, 01 Exp - 两行展示第二行
 */
Vue.filter('formatOptionName', (detail, mode) => {
  if (!detail.symbol) return ''
  // 兼容处理 [AAPL 20200302 330 CALL] 类似的数据结构
  let [symbol, expiry, strike, right] = detail.symbol.split(' ')
  expiry = detail.expiry || expiry
  strike = detail.strike || strike
  right = detail.right || right
  if (!symbol || !expiry || !strike || !right) return ''
  const now = moment().tz(TIME_ZONE.US)
  const expiryDate = moment(getOptionExpiryStamp(expiry)).tz(TIME_ZONE.US)
  const isSameYear = now.year() === expiryDate.year()
  const optionFormat =
    {
      'zh-cn': 'YYYYMMDD',
      'en-us': isSameYear ? 'MMM DD' : 'MMM DD, YYYY'
    }[store.getters.language] || 'YYYYMMDD'
  const expiryStr = expiryDate.format(optionFormat)
  const rightStr = right.toUpperCase()
  const oneLine = `${symbol} ${strike} ${rightStr} ${expiryStr}`
  const twoLine1 = `${symbol} ${strike} ${rightStr}`
  const twoLine2 = `${expiryStr} Exp`

  if (mode === null || mode === undefined) {
    return {
      oneLine,
      twoLine1,
      twoLine2
    }
  }
  // 一行展示期权信息
  if (mode === 0) {
    return oneLine
  }
  // 两行展示上
  if (mode === 1) {
    return twoLine1
  }
  // 两行展示下
  if (mode === 2) {
    return twoLine2
  }
})
